import { render, staticRenderFns } from "./info_table.vue?vue&type=template&id=46a54362&scoped=true"
import script from "./info_table.vue?vue&type=script&lang=ts"
export * from "./info_table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a54362",
  null
  
)

export default component.exports